import * as Yup from 'yup';
import { ScopeWasteType } from "models/ActivityDataEntryScopes/scopeThree.model";

// Utility function to check if any field in the scopeWasteType is filled
 export const isAnyFieldFilled = (fields: Partial<ScopeWasteType>): boolean =>
  !!fields.wasteTypeId || !!fields.treatmentMethod || !!fields.totalWasteProduced;

// Utility function for handling required fields validation
export const createRequiredTest = (fieldName: keyof ScopeWasteType, message: string) => 
  Yup.mixed().nullable().test(fieldName, message, function(value) {
    const parentFields = this.parent as ScopeWasteType;
    if (isAnyFieldFilled(parentFields) && (value === null || value === undefined)) {
      return this.createError({ message });
    }
    return true;
  });
